import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=d0fd12ee&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&id=d0fd12ee&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fd12ee",
  null
  
)

export default component.exports